const mutationTypes = {
  SET_LOADING: 'SET_LOADING',
  SET_TAGS: 'SET_TAGS'
}

const actionTypes = {
  FETCH_TAGS: 'FETCH_TAGS',
  CREATE_TAG: 'CREATE_TAG',
  DELETE_TAG: 'DELETE_TAG',
}

export {mutationTypes, actionTypes}



// WEBPACK FOOTER //
// ./src/store/modules/DatenpoolTagsTypes.js